import { render, staticRenderFns } from "./SkeletonAIMPContainer.vue?vue&type=template&id=a832d292&scoped=true"
import script from "./SkeletonAIMPContainer.vue?vue&type=script&lang=js"
export * from "./SkeletonAIMPContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a832d292",
  null
  
)

export default component.exports